export default "__VITE_ASSET__C_zHxc4V__"